import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from './global-variables';
import { BannersResponse } from '../shared/interfaces/banner.interface';
import {  handleError } from 'src/utils/error-helper';
@Injectable({
  providedIn: "root"
})
export class ApiService {

	constructor(
		private http: HttpClient,
		public GlobalConstants: GlobalConstants
	) {

	}
	reloadTemplate = new EventEmitter<any>();

	getUser(userId) {
		return this.http.get<any>(environment.apiUrlCsV1 + '/users/' + userId, {})
			.pipe(
				map(res => res || res),
				catchError(error => throwError(error))
			);
	}
	getUserDetails() {
		return this.http.get<any>(environment.apiUrlCsV1 + '/user', {})
			.pipe(
				map(res => res || res),
				catchError(error => throwError(error))
			);
	}

	getAllCountries() {
		return this.http.get(environment.apiUrlCsV1 + "/countries").pipe(
			map(res => res || []),
			handleError('Retrieval of  all countries failed')
		);
	}
	getApplicableCountries() {
		return this.http.get(environment.apiUrlPsV1 + "/countries").pipe(
			map(res => res || []),
			handleError('Retrieval of applicable countries failed')
		);
	}
	getUserCountry() {
		return this.http.get(environment.apiUrlCsV1 + "countries").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllCities(params) {
		return this.http.get(environment.apiUrlCsV1 + "/cities", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllInternationalCities(params) {
		return this.http.get(environment.apiUrlPsV1 + "/international_offers/cities", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllLocalities(params) {
		return this.http.get(environment.apiUrlCsV1 + "/localities", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getCards(params = {}) {
		return this.http.get<any>(environment.apiUrlCsV1 + '/user/user_cards', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}
	fetchCards(params = {}) {
		return this.http.get<any>(environment.apiUrlCsV1 + '/user/user_cards/fetch', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}

	getCardsWithPoints(params = {}) {
		return this.http.get<any>(environment.apiUrlCsV1 + '/user_card', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}

	binValidation(bin) {
		return this.http.get<any>(environment.apiUrlPsV1 + "/bins/card_details?bin=" + bin).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		)
	}
	cardValidation(bin) {
		return this.http.post<any>(environment.apiUrlCsV1 + "/bins/validate", {bin: bin}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		)
	}
	addCard(bin, bin_type ){
		return this.http.post<any>(environment.apiUrlCsV1 + "/user/user_cards", {bin: bin, bin_type : bin_type }).pipe(
		  map(res => res || []),
		  catchError(error => throwError(error))
		);
	}
	validateCard(bin, bin_type) {
		return this.http.post<any>(environment.apiUrlCsV1 + "/user/user_cards/search",{bin:bin, bin_type:bin_type}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getRedemptions(params = {}) {
		const httpOptions = {
      headers: new HttpHeaders({
        'exclude_project_id': 'true'
      })
    }
		return this.http.get(environment.apiUrlPsV1 + "redemptions?offer=true",httpOptions).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	public getOfferTags(params?): Observable<unknown> {
		return this.http.get(`${environment.apiUrlPsV1}/offers/offer_tags?elgble=true`, {params: params})
		.pipe(
			map(res => res || []),
			handleError('Retrieval of offer tags failed')
		  );
	}

	getOffers(params, isNearBy?, isInternational?) {
		return this.http.get(environment.apiUrlPsV1 + "/offers?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			handleError('Retrieval of offers failed')
		);
	}

	getCategories(params) {
		return this.http.get(environment.apiUrlPsV1 + "/categories?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getCategoryDetails(params = {}) {
		return this.http.get(environment.apiUrlPsV1 + "/category_details?elgble=true", {
			params
		}).pipe(
			map(res => res || []),
			handleError('Retrieval of category details failed')
		);
	}

	getCategoryDetail(id, params) {
		return this.http.get(environment.apiUrlPsV1 + "/category_details/" + id + "?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getMerchants(params) {
		// params['per_page'] = 100;
		return this.http.get(environment.apiUrlPsV1 + "/merchants?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	searchMerchants(params) {
		// params['per_page'] = 100;

		return this.http.get(environment.apiUrlPsV1 + "/merchants?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	redeem(offer, params) {
		return this.http.post(environment.apiUrlPsV1 + "offers/" + offer.id + "/redeem?elgble=true", params).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	redeemByBin(offer, bin) {
		return this.http.post(environment.apiUrlPsV1 + "offers/" + offer.id + "/redeem?elgble=true", { bin: bin }).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}


	checkCardEligibility(bin, bin_type, bundle_id) {
		return this.http.get(environment.apiUrlPsV1 + "/bins/validate?bin=" + bin + "&bundle_id=" + bundle_id).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}


	getBanners(params): Observable<BannersResponse> {
		return this.http.get<BannersResponse>(`${environment.apiUrlPsV1}client_banners`, {params}).pipe(
      map(res => res || []),
      handleError('Retrieval of banners failed')
    );
	}
	getTerms(id) {
		return this.http.get(environment.apiUrlPsV1 + "/offers/" + id + '/terms').pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	updateUserCreds(params){
		return this.http.put(environment.apiUrlCsV1 + "/user",params).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	resendEmail(){
		return this.http.post<any>(environment.apiUrlCsV1 +'/user/resend_email_verification', {}).pipe(
		  map(res => res || []),
		  catchError(error => throwError(error))
		);
	}
	
  addLocation(params) {
    return this.http.post<any>(environment.apiUrlCsV1 + "/user/user_locations/log", params).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }

}
